import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
import {
  getStorageData,
  removeStorageData,
  setStorageData,
} from "../../../framework/src/Utilities";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { CustomContext } from "../../../components/src/CustomContext.web";
import { navigateToUserProfile } from "../../../components/src/utils/userSlug.web";
import { clearUserIdFromAnalytics, logEvent, setUserIdForAnalytics } from "../../../components/src/utils/googleAnalytics/analyticsAdapter.web";

interface IProfile {
  id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  profileImg: string
  lastFetched: number
}

interface IEmailSuccessLoginParams {
  account_id: number;
  first_name: string;
  last_name: string;
  token: string;
  first_login: boolean;
  refreshToken: string;
  cometAuthToken: string;
}

interface ILoginUserDetails {
  account_id: number;
  first_name: string;
  last_name: string;
  first_login: boolean;
}

interface IEmailLoginPayload {
  email: string;
  password: string;
}

interface IEmailLoginSuccessResponse {
  message: string;
  meta: {
    token: string;
    first_name: string;
    last_name: string;
    first_login: boolean;
    refresh_token: string;
    account_id: number;
    comet_chat_auth_token: string;
    comet_chat_uid: string;
  };
}

interface IEmailLogin2FASuccessResponse {
  message: string;
  two_factor_enabled: boolean;
  full_phone_number: string;
}

interface IEmailLoginErrorResponse {
  errors: {
    [key: string]: string;
  }[];
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  password: string;
  email: string;
  enablePasswordField: boolean;
  checkedRememberMe: boolean;
  placeHolderEmail: string;
  placeHolderPassword: string;
  imgPasswordVisible: any;
  imgPasswordInVisible: any;
  labelHeader: string;
  btnTxtLogin: string;
  labelRememberMe: string;
  btnTxtSocialLogin: string;
  labelOr: string;
  forgotPassword: string;
  showPassword: boolean;
  isLoading: boolean;
  loginUserDetails: ILoginUserDetails | null;
  loginErrors: string[];
  isInfoDialogOpen: boolean;
  is2FAVerificationDialog: boolean;
  TwoFALoginPhoneNumber: string;
  isSessionInfoDialog: boolean;
  // Customizable Area End
}

interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class EmailAccountLoginController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  apiEmailLoginCallId: string = "";
  emailLoginApiCallId: string = "";
  validationApiCallId: string = "";
  emailReg: RegExp;
  tempEmailReg: string = "";
  labelTitle: string = "";
  redirectTimer: number | null = null;
  static contextType = CustomContext;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.CountryCodeMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.ReciveUserCredentials),
    ];

    this.state = {
      email: "",
      password: "",
      enablePasswordField: true,
      checkedRememberMe: false,
      placeHolderEmail: configJSON.placeHolderEmail,
      placeHolderPassword: configJSON.placeHolderPassword,
      imgPasswordVisible: configJSON.imgPasswordVisible,
      imgPasswordInVisible: imgPasswordInVisible,
      labelHeader: configJSON.labelHeader,
      btnTxtLogin: configJSON.btnTxtLogin,
      labelRememberMe: configJSON.labelRememberMe,
      btnTxtSocialLogin: configJSON.btnTxtSocialLogin,
      labelOr: configJSON.labelOr,
      forgotPassword: configJSON.forgotPassword,
      showPassword: false,
      isLoading: false,
      loginUserDetails: null,
      loginErrors: [],
      isInfoDialogOpen: false,
      is2FAVerificationDialog: false,
      TwoFALoginPhoneNumber: "",
      isSessionInfoDialog: false,
    };

    this.emailReg = new RegExp("");
    this.labelTitle = configJSON.labelTitle;
    // Customizable Area End

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    this.callGetValidationApi();
    this.send(new Message(getName(MessageEnum.RequestUserCredentials)));
    // Customizable Area Start
    this.handleSessionError();
    const isLoggedIn = await getStorageData(configJSON.TOKEN);
    if (!!isLoggedIn) {
      this.handlePageRedirection("Home");
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleSessionError = () => {
    const params = new URLSearchParams(window.location.search);
    const sessionError = params.get(configJSON.REASON_PARAM_KEY);
    if (sessionError === configJSON.sessionExpiredReason) {
      setTimeout(() => {
        this.setState({ isSessionInfoDialog: true });
      }, 100);
    }
  };

  async componentWillUnmount(): Promise<void> {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }

  get customContext(): React.ContextType<typeof CustomContext> {
    return this.context as React.ContextType<typeof CustomContext>;
  }

  btnSocialLoginProps = {
    onPress: () => this.goToSocialLogin(),
  };

  btnPasswordShowHideProps = {
    onPress: () => {
      this.setState({ enablePasswordField: !this.state.enablePasswordField });
      this.txtInputPasswordProps.secureTextEntry =
        !this.state.enablePasswordField;
      this.btnPasswordShowHideImageProps.source = this.txtInputPasswordProps
        .secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  // Web Event Handling
  handleClickShowPassword = () => {
    this.setState({
      enablePasswordField: !this.state.enablePasswordField,
    });
  };

  setEmail = (text: string) => {
    this.setState({
      email: text,
    });
  };

  setPassword = (text: string) => {
    this.setState({
      password: text,
    });
  };

  CustomCheckBoxProps = {
    onChangeValue: (value: boolean) => {
      this.setState({ checkedRememberMe: value });
      this.CustomCheckBoxProps.isChecked = value;
    },
    isChecked: false,
  };

  txtInputPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ password: text });

      //@ts-ignore
      this.txtInputPasswordProps.value = text;
    },
    secureTextEntry: true,
  };

  btnPasswordShowHideImageProps = {
    source: imgPasswordVisible,
  };

  btnRememberMeProps = {
    onPress: () => {
      this.setState({ checkedRememberMe: !this.CustomCheckBoxProps.isChecked });
      this.CustomCheckBoxProps.isChecked = !this.CustomCheckBoxProps.isChecked;
    },
  };

  txtInputEmailWebProps = {
    onChangeText: (text: string) => {
      this.setState({ email: text });

      //@ts-ignore
      this.txtInputEmailProps.value = text;
    },
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  txtInputEmailMobileProps = {
    ...this.txtInputEmailWebProps,
    autoCompleteType: "email",
    keyboardType: "email-address",
  };

  txtInputEmailProps = this.isPlatformWeb()
    ? this.txtInputEmailWebProps
    : this.txtInputEmailMobileProps;

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  handleForgotPassRedirect = () => {
    logEvent("forgot_password_request", { method: "email" });
    this.handlePageRedirection("ForgotPassword");
  };

  emailLoginApi = (loginDetails: IEmailLoginPayload) => {
    const header = {
      "Content-Type": configJSON.loginApiContentType,
    };

    const httpBody = { ...loginDetails };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.emailLoginApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.emailLoginApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  };

  initCometChat = async (cometAuthToken: string) => {
    try {
      const user = await CometChat.getLoggedinUser();

      if (!user) {
        const loggedInUser = await CometChat.login(cometAuthToken);
        if (!loggedInUser) {
          throw new Error("CometChat login failed");
        }
        await setStorageData(configJSON.COMET_AUTH_TOKEN_KEY, cometAuthToken);
      }
    } catch (error: any) {
      throw error;
    }
  };

  handleSuccessLogin = async (loginDetails: IEmailSuccessLoginParams) => {
    try {
      setUserIdForAnalytics(loginDetails.account_id)
      logEvent("login", { method: "email" });
      const {
        account_id,
        token,
        refreshToken,
        first_name,
        last_name,
        first_login,
        cometAuthToken,
      } = loginDetails;
      await this.initCometChat(cometAuthToken);
      await setStorageData(configJSON.TOKEN, token);
      const userProfile: IProfile = {
        id: String(account_id),
        firstName: first_name,
        lastName: last_name,
        email: "",
        phoneNumber: "",
        profileImg: "",
        lastFetched: Date.now() - 1.5 * 60 * 60 * 1000
      }
      await setStorageData(configJSON.PROFILE_KEY, JSON.stringify(userProfile))
      await setStorageData(configJSON.REFRESH_TOKEN, refreshToken);
      this.customContext.setIsLoggedIn(true);
      this.handleClose2FADialog();
      this.setState({
        isLoading: false,
        isInfoDialogOpen: true,
        loginUserDetails: {
          account_id,
          first_name,
          last_name,
          first_login,
        },
      });
      this.redirectTimer = window.setTimeout(() => {
        this.handleCloseInfoDialog();
      }, 2000);
    } catch (error) {
      clearUserIdFromAnalytics()
      await removeStorageData(configJSON.TOKEN);
      await removeStorageData(configJSON.REFRESH_TOKEN);
      this.customContext.setIsLoggedIn(false);
      this.handleClose2FADialog();
      this.setState({
        isLoading: false,
        loginErrors: ["Something went wrong"],
      });
    }
  };

  handleEmailLogin = (values: IEmailLoginPayload) => {
    this.handleFullPageLoader(true);
    this.setState({ loginErrors: [] });
    this.emailLoginApi({ ...values, email: values.email.trim() });
  };

  handleEmailLoginResponse = async (
    responseJson:
      | IEmailLoginSuccessResponse
      | IEmailLogin2FASuccessResponse
      | IEmailLoginErrorResponse
  ) => {
    if ("errors" in responseJson) {
      const { errors } = responseJson;
      const loginErrors = errors.flatMap((error) => Object.values(error));
      this.setState({ loginErrors, isLoading: false });
    } else if ("two_factor_enabled" in responseJson) {
      let { full_phone_number } = responseJson;
      if (full_phone_number.startsWith("91")) {
        full_phone_number = full_phone_number.slice(2);
      }
      this.setState({
        isLoading: false,
        is2FAVerificationDialog: true,
        TwoFALoginPhoneNumber: full_phone_number,
      });
    } else {
      const {
        meta: {
          account_id,
          token,
          refresh_token,
          first_name,
          last_name,
          first_login,
          comet_chat_auth_token,
        },
      } = responseJson;
      const loginDetails: IEmailSuccessLoginParams = {
        token,
        first_login,
        account_id,
        first_name,
        last_name,
        refreshToken: refresh_token,
        cometAuthToken: comet_chat_auth_token,
      };
      this.handleSuccessLogin(loginDetails);
    }
  };

  handleCloseInfoDialog = () => {
    const { loginUserDetails } = this.state;
    if (loginUserDetails && loginUserDetails?.first_login) {
      const { account_id, first_name, last_name } = loginUserDetails;
      navigateToUserProfile(this.props.navigation, {
        id: String(account_id),
        firstName: first_name,
        lastName: last_name
      });
    } else {
      this.handlePageRedirection("Home");
    }
  };

  handleCloseSessionInfoDialog = () => {
    this.setState({ isSessionInfoDialog: false });
  };

  handleFullPageLoader = (isLoading: boolean = false) => {
    this.setState({ isLoading });
  };

  handleClose2FADialog = () => {
    this.setState({ is2FAVerificationDialog: false });
  };

  handleSuccessPhoneVerified = async (
    loginDetails: IEmailSuccessLoginParams
  ) => {
    this.handleSuccessLogin(loginDetails);
  };
  // Customizable Area End

  async receive(from: string, message: Message) {
    // Customizable Area Start

    if (getName(MessageEnum.ReciveUserCredentials) === message.id) {
      const userName = message.getData(getName(MessageEnum.LoginUserName));

      const password = message.getData(getName(MessageEnum.LoginPassword));

      const countryCode = message.getData(
        getName(MessageEnum.LoginCountryCode)
      );

      if (!countryCode && userName && password) {
        this.setState({
          email: userName,
          password: password,
          checkedRememberMe: true,
        });

        //@ts-ignore
        this.txtInputEmailProps.value = userName;

        //@ts-ignore
        this.txtInputPasswordProps.value = password;

        this.CustomCheckBoxProps.isChecked = true;
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      var errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (apiRequestCallId != null) {
        if (apiRequestCallId === this.apiEmailLoginCallId) {
          if (responseJson && responseJson.meta && responseJson.meta.token) {
            runEngine.unSubscribeFromMessages(this, this.subScribedMessages);
            this.saveLoggedInUserData(responseJson);
            this.sendLoginSuccessMessage();
            this.openInfoPage();
          } else {
            //Check Error Response
            this.parseApiErrorResponse(responseJson);
            this.sendLoginFailMessage();
          }

          this.parseApiCatchErrorResponse(errorReponse);
        }

        if (apiRequestCallId === this.emailLoginApiCallId) {
          this.handleEmailLoginResponse(responseJson);
        }
      }
    }
  }

  sendLoginFailMessage() {
    const msg: Message = new Message(getName(MessageEnum.LoginFaliureMessage));
    this.send(msg);
  }

  sendLoginSuccessMessage() {
    const msg: Message = new Message(getName(MessageEnum.LoginSuccessMessage));

    msg.addData(getName(MessageEnum.LoginUserName), this.state.email);
    msg.addData(getName(MessageEnum.CountyCodeDataMessage), null);
    msg.addData(getName(MessageEnum.LoginPassword), this.state.password);
    msg.addData(
      getName(MessageEnum.LoginIsRememberMe),
      this.state.checkedRememberMe
    );

    this.send(msg);
  }

  saveLoggedInUserData(responseJson: any) {
    if (responseJson && responseJson.meta && responseJson.meta.token) {
      const msg: Message = new Message(getName(MessageEnum.SessionSaveMessage));

      msg.addData(
        getName(MessageEnum.SessionResponseData),
        JSON.stringify(responseJson)
      );
      msg.addData(
        getName(MessageEnum.SessionResponseToken),
        responseJson.meta.token
      );

      this.send(msg);
    }
  }

  openInfoPage() {
    const msg: Message = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  goToForgotPassword() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationForgotPasswordMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    msg.addData(getName(MessageEnum.NavigationForgotPasswordPageInfo), "email");
    this.send(msg);
  }

  goToSocialLogin() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationSocialLogInMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  doEmailLogIn(): boolean {
    if (
      this.state.email === null ||
      this.state.email.length === 0 ||
      !this.emailReg.test(this.state.email)
    ) {
      this.showAlert("Error", configJSON.errorEmailNotValid);
      return false;
    }

    if (this.state.password === null || this.state.password.length === 0) {
      this.showAlert("Error", configJSON.errorPasswordNotValid);
      return false;
    }

    const header = {
      "Content-Type": configJSON.loginApiContentType,
    };

    const attrs = {
      email: this.state.email,
      password: this.state.password,
    };

    const data = {
      type: "email_account",
      attributes: attrs,
    };

    const httpBody = {
      data: data,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.apiEmailLoginCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.loginAPiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.loginAPiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  }

  callGetValidationApi() {
    this.tempEmailReg = "";
  }

  handleNavigation = (path: string) => {
    logEvent('button_click', { button_name: path })
    this.props.navigation.navigate(path);
  };
}
// Customizable Area End
